/*
 * QuestionGroup Messages
 *
 * This contains all the text for the QuestionGroup component.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.components.QuestionGroup';

export default defineMessages({
  choicesOpenEnded: {
    id: `${scope}.choicesOpenEnded`,
    defaultMessage: 'Choices & Open Ended',
  },
  questionGroups: {
    id: `${scope}.questionGroups`,
    defaultMessage: 'Question Groups',
  },
  scaleComparative: {
    id: `${scope}.scaleComparative`,
    defaultMessage: 'Scales & Comparative',
  },
  questionsResearchMethods: {
    id: `${scope}.questionsResearchMethods`,
    defaultMessage: 'Questions & Research Methods',
  },
  moreActions: {
    id: `${scope}.moreActions`,
    defaultMessage: 'More Actions',
  },
  group: {
    id: `${scope}.group`,
    defaultMessage: 'Group {nodeIndex}',
  },
  abtest: {
    id: `${scope}.abtest`,
    defaultMessage: 'A/B Test',
  },
  conjoint: {
    id: `${scope}.conjoint`,
    defaultMessage: 'Conjoint',
  },
  vanWestendorpShort: {
    id: `${scope}.vanWestendorpShort`,
    defaultMessage: 'PSM {nodeIndex}',
  },
  vanWestendorp: {
    id: `${scope}.vanWestendorp`,
    defaultMessage: 'Pricing study (Van Westendorp) {nodeIndex}',
  },
  maxDiff: {
    id: `${scope}.maxDiff`,
    defaultMessage: 'Maxdiff',
  },
  researchMethods: {
    id: `${scope}.researchMethods`,
    defaultMessage: 'Research Methods',
  },
  questionTypes: {
    id: `${scope}.questionTypes`,
    defaultMessage: 'Question types',
  },
  screeningQuestions: {
    id: `${scope}.screeningQuestions`,
    defaultMessage: 'Screening Questions',
  },
  dragQuestionHere: {
    id: `${scope}.dragQuestionHere`,
    defaultMessage: 'Drag and drop or',
  },
  moveQuestionBtn: {
    id: `${scope}.moveQuestionBtn`,
    defaultMessage: 'move questions',
  },
  here: {
    id: `${scope}.here`,
    defaultMessage: 'here',
  },
  groupHeaderTitle: {
    id: `${scope}.groupHeaderTitle`,
    defaultMessage: 'Group {index}',
  },
  groupTitleNoSpace: {
    id: `${scope}.groupTitleNoSpace`,
    defaultMessage: 'Group{index}',
  },
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Type a name for your group...',
  },
  abSettings: {
    defaultQuestions: {
      id: `${scope}.abSettings.defaultQuestions`,
      defaultMessage: 'Default questions',
    },
    autoDistribution: {
      id: `${scope}.abSettings.autoDistribution`,
      defaultMessage: 'Auto Distribution',
    },
    customDistribution: {
      id: `${scope}.abSettings.customDistribution`,
      defaultMessage: 'Custom Distribution',
    },
    abTestTypeLabel: {
      id: `${scope}.abSettings.abTestTypeLabel`,
      defaultMessage: 'A/B Test Type',
    },
    monadic: {
      id: `${scope}.abSettings.monadic`,
      defaultMessage: 'Monadic',
    },
    sequential: {
      id: `${scope}.abSettings.sequential`,
      defaultMessage: 'Sequential',
    },
    sequentialItems: {
      id: `${scope}.abSettings.sequentialItems`,
      defaultMessage: 'Number of concepts presented per respondent',
    },
    likelihood: {
      id: `${scope}.abSettings.likelihood`,
      defaultMessage: 'Likelihood to purchase Question',
    },
    abShowAttributesTitle: {
      id: `${scope}.abSettings.abShowAttributesTitle`,
      defaultMessage: 'Shown Attributes',
    },
    abShowAttributesTooltip: {
      id: `${scope}.abSettings.abShowAttributesTooltip`,
      defaultMessage:
        'Select which A/B Test attributes will be visible on this question',
    },
  },
  doeSettings: {
    choiceSetSize: {
      id: `${scope}.doeSettings.choiceSetSize`,
      defaultMessage: 'Alternatives per choice set',
    },
    choiceSetSizeTooltip: {
      id: `${scope}.doeSettings.choiceSetSizeTooltip`,
      defaultMessage:
        'The number of product alternatives per choice set (i.e. the number of product concepts presented in each question) gets generated by Pollfish {groupName} algorithm. You can preview the {groupName} question by clicking on the "Generate Preview" button.',
    },
    repetitions: {
      id: `${scope}.doeSettings.repetitions`,
      defaultMessage: 'Maximum number of choice <br /> sets per respondent',
    },
    repetitionsTooltip: {
      id: `${scope}.doeSettings.repetitionsTooltip`,
      defaultMessage:
        'The number of questions (choice sets) presented to each respondent, gets generated by Pollfish {groupName} algorithm. You can preview the {groupName} question by clicking on the "Generate Preview" button.',
    },
    nodeOfTheAbove: {
      id: `${scope}.doeSettings.nodeOfTheAbove`,
      defaultMessage: 'Include "None of the above"',
    },
    excludeCombinations: {
      id: `${scope}.doeSettings.excludeCombinations`,
      defaultMessage: 'Exclude Combinations',
    },
    excludeCombinationsPlaceholder: {
      id: `${scope}.doeSettings.excludeCombinationsPlaceholder`,
      defaultMessage: 'Select levels to exclude',
    },
    excludeCombinationsMessage: {
      id: `${scope}.doeSettings.excludeCombinationsMessage`,
      defaultMessage:
        'You can prohibit the generation of unrealistic alternatives by using the "Exclude Combinations" setting. We advise prohibited pairs to be no more than 4.',
    },
    addExcludedCombination: {
      id: `${scope}.doeSettings.addExcludedCombination`,
      defaultMessage: '+ Add Excluded Combination',
    },
  },
  vanWestenDorpSettings: {
    pricingQuestions: {
      id: `${scope}.vanWestenDorpSettings.pricingQuestions`,
      defaultMessage: 'Pricing questions',
    },
    questionOrder: {
      id: `${scope}.vanWestenDorpSettings.questionOrder`,
      defaultMessage: 'Question order',
    },
    allowDecimals: {
      id: `${scope}.vanWestenDorpSettings.allowDecimals`,
      defaultMessage: 'Allow decimal numbers',
    },
    limitRanges: {
      id: `${scope}.vanWestenDorpSettings.limitRanges`,
      defaultMessage: 'Limit price ranges',
    },
    likelihoodToPurchase: {
      id: `${scope}.vanWestenDorpSettings.likelihoodToPurchase`,
      defaultMessage: 'Include likelihood to purchase questions',
    },
  },
  maxDiffSetting: {
    messaging: {
      id: `${scope}.maxDiffSetting.messaging`,
      defaultMessage: 'Messaging',
    },
    messagingPlaceholderBest: {
      id: `${scope}.maxDiffSetting.messagingPlaceholderBest`,
      defaultMessage: 'Type a label for the best choice',
    },
    messagingPlaceholderWorst: {
      id: `${scope}.maxDiffSetting.messagingPlaceholderWorst`,
      defaultMessage: 'Type a label for the worst choice',
    },
  },
  errors: {
    emptyGroup: {
      id: `${scope}.errors.emptyGroup`,
      defaultMessage: 'Please add some questions or remove group',
    },
    emptyAttributeContent: {
      id: `${scope}.errors.emptyAttributeContent`,
      defaultMessage: 'Please add content to all the attributes',
    },
    emptyAttributeContentVw: {
      id: `${scope}.errors.emptyAttributeContentVw`,
      defaultMessage:
        'Enhance your product presentation so that respondents have a good understanding of your product.',
    },
    noAttributes: {
      id: `${scope}.errors.noAttributes`,
      defaultMessage: 'Please add some attributes',
    },
    emptyOrOneLevelInExcludedCombination: {
      id: `${scope}.errors.emptyOrOneLevelInExcludedCombination`,
      defaultMessage:
        'Please fill out all excluded combinations with at least two levels per combination',
    },
    brandOrPriceTypeAttributesMoreThanOne: {
      id: `${scope}.errors.brandOrPriceTypeAttributesMoreThanOne`,
      defaultMessage:
        'Conjoint can have only one attribute with type Brand and only attribute with type Price',
    },
    priceTypeAttributesMoreThanOne: {
      id: `${scope}.errors.priceTypeAttributesMoreThanOne`,
      defaultMessage: '{groupName} can have only one attribute with type Price',
    },
    brandTypeAttributesMoreThanOne: {
      id: `${scope}.errors.brandTypeAttributesMoreThanOne`,
      defaultMessage: 'Conjoint can have only one attribute with type Brand',
    },
    missingVariables: {
      id: `${scope}.errors.missingVariables`,
      defaultMessage:
        'Variable fields cannot be empty. Please fill them out to continue.',
    },
    missingVariableNames: {
      id: `${scope}.errors.missingVariableNames`,
      defaultMessage:
        'Variable names cannot be empty. Please fill them out to continue.',
    },
    loopAndMergeRepetitionsOutOfLimits: {
      id: `${scope}.errors.loopAndMergeRepetitionsOutOfLimits`,
      defaultMessage:
        'The maximum number of loops for the group are out of bounds, based on the configuration.',
    },
    loopAndMergeConfigIncomplete: {
      id: `${scope}.errors.loopAndMergeConfigIncomplete`,
      defaultMessage: 'Please complete the Loop and Merge group configuration.',
    },
    loopAndMergeConfigInvalidSourceQuestion: {
      id: `${scope}.errors.loopAndMergeConfigInvalidSourceQuestion`,
      defaultMessage:
        'The question the Loop and Merge group is based off, does not preceed the group.',
    },
    loopAndMergeOnlyQuestionWithAudienceConfig: {
      id: `${scope}.errors.loopAndMergeOnlyQuestionWithAudienceConfig`,
      defaultMessage:
        'Your Loop and Merge configuration is based on a demographic question. Please ensure that at least one additional question exists outside the Loop and Merge group in the questionnaire.',
    },
  },
});
